import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import PlayerReportCashForm from '../../../components/admin/playerReport/PlayerReportCashForm'
import PlayerReportCashTable from '../../../components/admin/playerReport/PlayerReportCashTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const PlayerReportCashPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.PLATFORMS, Branch.PUBLISHERS])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <PlayerReportCashForm />
      </Box>
      <Box paddingTop={3}>
        <PlayerReportCashTable />
      </Box>
    </Box>
  )
}

export default React.memo(PlayerReportCashPage)
